/**
 * IVONO audience (B2C/B2B): zakelijke klanten zien prijzen excl. btw.
 *
 * - Keuze via de header-toggle wordt bewaard (localStorage 'iv-audience');
 *   in de theme-editor wordt die bewaarde keuze genegeerd (27/08);
 *   ingelogde zakelijke klanten (Shopify B2B of tag b2b/zakelijk, via
 *   body[data-customer-b2b]) starten op zakelijk.
 * - De doelgroep is ook via de URL te zetten: ?audience=b2b of ?audience=b2c
 *   (aliassen: business/zakelijk/bedrijf/company en consumer/particulier/
 *   consument/private). Dat werkt op elke pagina en in beide talen, wint van
 *   de bewaarde keuze, en wordt bewaard alsof de bezoeker de schakelaar had
 *   geklikt. Na verwerking haalt hij de parameter met history.replaceState uit
 *   de adresbalk, zodat hij niet in deel-links en analytics-urls blijft hangen.
 *   Bedoeld voor knoppen/links buiten het theme (cookiebalk, e-mail, campagne):
 *   https://www.ivono.eu/?audience=b2b — zie docs/build/qa-audience-url.mjs.
 * - Alle Liquid-gerenderde prijzen dragen data-iv-price="<centen incl. btw>";
 *   deze module herschrijft ze naar excl. btw (÷ 1 + vat/100) en herstelt de
 *   originele tekst bij terugschakelen. AJAX-re-renders (cart-drawer,
 *   zoeksuggesties) worden via een MutationObserver meegenomen.
 * - JS die zelf prijzen schrijft (product-hero, suggesties) gebruikt
 *   window.IVAudience.display(cents) zodat die schrijfacties direct de juiste
 *   variant tonen; 'iv:audience' event voor secties die willen her-renderen.
 */
(function () {
  'use strict';

  var KEY = 'iv-audience';
  var URL_PARAM = 'audience';

  // Waarden die de URL-parameter accepteert. Naast de interne codes ook de
  // woorden die in een knoplabel passen, zodat een link die iemand buiten dit
  // theme samenstelt (cookiebalk, nieuwsbrief, campagne) leesbaar kan blijven.
  var URL_WAARDEN = {
    b2b: 'b2b',
    business: 'b2b',
    zakelijk: 'b2b',
    bedrijf: 'b2b',
    company: 'b2b',
    b2c: 'b2c',
    consumer: 'b2c',
    particulier: 'b2c',
    consument: 'b2c',
    private: 'b2c',
  };

  /** Doelgroep uit ?audience= — null als de parameter ontbreekt of onbekend is. */
  function urlAudience() {
    try {
      var v = new URLSearchParams(window.location.search).get(URL_PARAM);
      if (!v) return null;
      return URL_WAARDEN[v.trim().toLowerCase()] || null;
    } catch (e) {
      return null;
    }
  }

  // Parameter uit de adresbalk halen zonder de pagina te herladen: het taalpad
  // (/nl), andere query-parameters (utm_*, variant) en de hash blijven staan.
  // Semantisch gelijk, niet per se byte-identiek: searchParams.toString()
  // herserialiseert de rest (een spatie wordt +, een valueloze ?foo wordt foo=).
  // Alleen bij een HERKENDE waarde, zodat een tikfout zichtbaar blijft en een
  // gelijknamige parameter van iets anders niet stilletjes verdwijnt.
  function stripUrlParam() {
    if (!window.history || !window.history.replaceState || !urlAudience()) return;
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has(URL_PARAM)) return;
      u.searchParams.delete(URL_PARAM);
      var zoek = u.searchParams.toString();
      window.history.replaceState(window.history.state, '', u.pathname + (zoek ? '?' + zoek : '') + u.hash);
    } catch (e) {
      /* oude browser of exotische url: parameter blijft gewoon staan */
    }
  }

  function fmt(cents) {
    var euros = cents / 100;
    var whole = Math.floor(euros);
    var frac = Math.round((euros - whole) * 100);
    if (frac === 100) {
      whole += 1;
      frac = 0;
    }
    var intStr = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (frac === 0) return '€' + intStr;
    return '€' + intStr + ',' + (frac < 10 ? '0' + frac : frac);
  }

  // Winkelwagen-samenvatting gebruikt het vaste "€ 1.234,56"-formaat (Figma).
  function fmtStyled(cents, style) {
    if (style === 'summary') {
      var euros = cents / 100;
      var whole = Math.floor(euros);
      var frac = Math.round((euros - whole) * 100);
      if (frac === 100) {
        whole += 1;
        frac = 0;
      }
      var intStr = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '€ ' + intStr + ',' + (frac < 10 ? '0' + frac : frac);
    }
    return fmt(cents);
  }

  var current = 'b2c';
  var factor = 1.21;
  var observer = null;
  var syncedAudience = null;
  var cartItems = 0;

  // Maakt de toggle-keuze zichtbaar voor de checkout: de "Op factuur"-regel
  // (Checkout Blocks) en het B2B-hintblok lezen het cart-attribute
  // `_audience`. Underscore-prefix: leesbaar voor checkout-extensies en
  // Functions, niet prominent in de ordersamenvatting. Stil falen — de
  // toggle mag nooit breken op een netwerkfout, en zonder attribute blijft
  // "Op factuur" gewoon verborgen (de veilige kant).
  /* Wat er al op de winkelwagen staat, uit het JSON-blok van iv-cart-delivery: zonder
     deze vergelijking schreef elke paginalading opnieuw een /cart/update.js met dezelfde
     waarde (QA 26/08). */
  (function leesHuidigeAudience() {
    try {
      var el = document.querySelector('[data-iv-cart-delivery]');
      if (!el) return;
      var d = JSON.parse(el.textContent);
      var a = d && d.huidig && d.huidig.audience;
      if (a) syncedAudience = a;
      cartItems = (d && typeof d.items === 'number') ? d.items : 0;
    } catch (e) { /* geen blok of ongeldige json: dan schrijft hij gewoon één keer */ }
  })();

  function syncCartAttribute() {
    if (current === syncedAudience || !window.fetch) return;
    syncedAudience = current;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _audience: current } }),
    }).catch(function () {
      // Volgende set()/pageload probeert opnieuw.
      syncedAudience = null;
    });
  }

  function initial() {
    var s = null;
    // In de theme-editor (Shopify.designMode) de onthouden keuze negeren, zodat de
    // editor altijd de instelling "Standaard doelgroep" toont (Mehmet 27/08: hij zag
    // steeds Business omdat zijn browser die keuze had bewaard). Bezoekers merken niets.
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    // ?audience= wint van alles: dat is een expliciete keuze van de bezoeker,
    // net als een klik op de schakelaar, en wordt dus ook bewaard. In de
    // theme-editor niet bewaren (zelfde reden als hieronder: de editor hoort de
    // instelling "Standaard doelgroep" te tonen, niet een blijvende keuze).
    var uitUrl = urlAudience();
    if (uitUrl) {
      if (!inEditor) {
        try {
          localStorage.setItem(KEY, uitUrl);
        } catch (e) {
          /* private mode */
        }
      }
      return uitUrl;
    }
    try {
      s = inEditor ? null : localStorage.getItem(KEY);
    } catch (e) {
      /* private mode */
    }
    if (s === 'b2b' || s === 'b2c') return s;
    if (document.body.dataset.customerB2b === 'true') return 'b2b';
    var active = document.querySelector('.iv-header__audience-option.is-active');
    return active && active.dataset.audience === 'b2b' ? 'b2b' : 'b2c';
  }

  function apply(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-iv-price]').forEach(function (el) {
      var cents = parseInt(el.dataset.ivPrice, 10);
      if (isNaN(cents) || cents <= 0) return;
      // Beide staten uit de centen berekenen (fmt matcht money_without_trailing_zeros),
      // zodat dynamische her-writes nooit een stale "origineel" achterlaten.
      var net = current === 'b2b' ? Math.round(cents / factor) : cents;
      var want = fmtStyled(net, el.dataset.ivStyle);
      if (el.textContent !== want) el.textContent = want;
    });
    scope.querySelectorAll('[data-iv-vat-note]').forEach(function (el) {
      var want = current === 'b2b' ? el.dataset.noteExcl : el.dataset.noteIncl;
      if (want && el.textContent !== want) el.textContent = want;
    });
    // Zelf-veroorzaakte mutaties niet opnieuw verwerken.
    if (observer) observer.takeRecords();
  }

  function syncToggles() {
    document.querySelectorAll('.iv-header__audience-option').forEach(function (o) {
      o.classList.toggle('is-active', o.dataset.audience === current);
    });
  }

  window.IVAudience = {
    isB2B: function () {
      return current === 'b2b';
    },
    display: function (cents) {
      return current === 'b2b' ? fmt(Math.round(cents / factor)) : fmt(cents);
    },
    refresh: function (root) {
      apply(root);
    },
    set: function (aud) {
      current = aud === 'b2b' ? 'b2b' : 'b2c';
      try {
        localStorage.setItem(KEY, current);
      } catch (e) {
        /* private mode */
      }
      document.documentElement.classList.toggle('iv-audience-b2b', current === 'b2b');
      syncToggles();
      apply();
      syncCartAttribute();
      document.dispatchEvent(new CustomEvent('iv:audience', { detail: { audience: current } }));
    },
  };

  function start() {
    var vat = parseFloat(document.body.dataset.vatRate || '21');
    if (!isNaN(vat) && vat > 0) factor = 1 + vat / 100;
    current = initial();
    // Zo vroeg mogelijk opruimen (dit bestand staat met `defer` in de head, dus
    // dit draait vóór DOMContentLoaded): de parameter hoort niet in deel-links,
    // bookmarks of analytics-urls. De canonical is server-side en draagt sowieso
    // geen query-parameters, dus die blijft ongemoeid.
    stripUrlParam();
    document.documentElement.classList.toggle('iv-audience-b2b', current === 'b2b');
    syncToggles();
    apply();
    // Alleen syncen als er al een winkelwagen mét items is (sweep 28/08: op een leeg
    // bezoek schreef elke paginalading een /cart/update.js en maakte zo voor élke
    // bezoeker een lege cart aan). Het kenmerk telt pas in de checkout; na een add-to-cart
    // vuurt het theme cart:refresh en dan zetten we het alsnog.
    if (cartItems > 0) syncCartAttribute();
    document.addEventListener('cart:refresh', function () {
      cartItems = 1;
      syncCartAttribute();
    });
    // Secties die vóór deze module initialiseerden (render-volgorde van de
    // bundels is niet gegarandeerd) alsnog laten bijtrekken.
    document.dispatchEvent(new CustomEvent('iv:audience', { detail: { audience: current } }));
    observer = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          apply();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
